<div class="special-offer-container">
    @if (onSalePeriodProductList().length > 0) {
        <div class="materials-container-special-offer">
            <div class="material-container-published">
                @for (onSalePeriodProduct of onSalePeriodProductList(); track $index; let i = $index) {
                    <div class="published">
                        <div class="pub-container">
                            <div class="pubb">
                                <h3>{{ onSalePeriodProduct.name | uppercase }}</h3>
                            </div>
                            @if (i === 0) {
                                <div class="easter-discount-text">
                                    <b>
                                        {{ 'shoppingCart.freeDelivery' | translate }}
                                        <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7" target="_blank">
                                            <mat-icon>info</mat-icon>
                                        </a>
                                    </b>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="books-container">
                        @for (product of onSalePeriodProduct.productOnSaleList; track product.routerLink) {
                            <app-product-preview [product]="mapToMaterial(product)" (addToCart)="addToCartDiscountedBook($event)" />
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
